module.exports = __webpack_public_path__ + "img/page_left.8ff33355.svg";